import React from 'react';
import { Column, Row } from 'web-ui-components/lib/global/layout';

import AccountCardHomePageList from './AccountCardHomePageList';

function HomepageTilesAccountsList({
  accounts = [],
  content,
  goToAccountDetails,
}) {
  return (
    <span>
      <Row>
        <Column lg={24}>
          {accounts.map((account, index) => (
            <AccountCardHomePageList
              content={content}
              account={account}
              index={index}
              goToAccountDetails={goToAccountDetails}
              key={`HomepageTilesAccountsList_AccountCardHomePageList_${index}`}
            />
          ))}
        </Column>
      </Row>
    </span>
  );
}

export default HomepageTilesAccountsList;
